import { render } from "./ProjectCharts.vue?vue&type=template&id=5f973750&scoped=true"
import script from "./ProjectCharts.vue?vue&type=script&lang=js"
export * from "./ProjectCharts.vue?vue&type=script&lang=js"

import "./ProjectCharts.vue?vue&type=style&index=0&id=5f973750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f973750"],['__file',"src/components/project/ProjectCharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f973750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f973750', __exports__)) {
    api.reload('5f973750', __exports__)
  }
  
  module.hot.accept("./ProjectCharts.vue?vue&type=template&id=5f973750&scoped=true", () => {
    api.rerender('5f973750', render)
  })

}


export default __exports__